import React from "react";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { PageHeading } from "../../components";
import RequestCreateAlert from "../requests/components/RequestCreateAlert";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import CustomerContactPeopleBox from "./components/CustomerContactPeopleBox";
import CustomerBasicInfoBox from "./components/CustomerBasicInfoBox";
import { useGetCompanyCustomerInfoQuery } from "../../common/queries";
import CustomerAddressesBox from "./components/CustomerAddressesBox";

const CustomerInfoPage: React.FC = (): React.ReactElement => {
  const { tRequest, tCustomer, tCommon } = useCustomTranslation();

  const companyAndCustomerQuery = useGetCompanyCustomerInfoQuery();

  const customer = companyAndCustomerQuery.data?.customer;

  return (
    <ContentWrapper
      loading={companyAndCustomerQuery.isLoading || !customer}
      htmlTitle={tCommon("menu_customer")}
    >
      {customer && (
        <>
          <PageHeading title={tCustomer("customer_portal_customer_data")} />
          <p className="mb-4">{tCustomer("customer_saved_data_description")}</p>
          <div className="grid grid-flow-col gap-x-4 gap-y-1.5">
            <CustomerBasicInfoBox customer={customer} />
          </div>
          <div className="grid grid-cols-1 gap-x-4 sm:grid-cols-2">
            <CustomerContactPeopleBox
              contactPeople={customer.contactPeople}
              primaryContactPersonId={customer.primaryContactPerson?.id ?? ""}
            />
            <CustomerAddressesBox
              addresses={customer.addresses}
              contactAddressId={customer.contactAddress?.id}
              invoiceAddressId={customer.invoiceAddress?.id}
            />
          </div>
          <RequestCreateAlert
            title={tRequest("change_data")}
            description={tRequest("change_data_description")}
            requestPageParams={{ formType: "DataUpdate" }}
          />
        </>
      )}
    </ContentWrapper>
  );
};

export default CustomerInfoPage;
